import { DiContainerInjectFn } from '@@/di/ts';
import { AgricultureService } from '@@/agriculture/services/agriculture.service';
import { AgricultureParametersService } from '@@/agriculture/services/agriculture-parameters.service';

export default ((container) => {
  container
    .bind(AgricultureParametersService)
    .to(AgricultureParametersService)
    .inSingletonScope();
  
  container.bind(AgricultureService).to(AgricultureService).inSingletonScope();
}) as DiContainerInjectFn;
